import {
  Card,
  Grid,
  TextField,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import AppService from "../../../../Configurations/Appservice";
import { useState, useEffect } from "react";
import { PARTNER_ORG_TYPE, PARTNER_USER_TYPE } from "../../../../Configurations/AppConfig";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import uuid from "react-uuid";
import SubTitle from "../../../../Components/SubTitle";

const initialValues = {
  amount: "",
  organisationId: "",
  paymentMethod: "",
};

const validationSchema = object({
  amount: string().required("Amount is Mandatory"),
  organisationId: string().required("Service is Mandatory"),
  paymentMethod: string().required("Payment Method is Mandatory"),
});

const PartnerPayment = () => {
  const [organisations, setOrganisations] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showLoader());

    const organisationUrl = "v1/organisation/keyValues?type=PARTNER";
    const paymentMethodUrl = "v1/paymentMethod/keyValues";
    let endpoints = [organisationUrl, paymentMethodUrl];
    Promise.all(endpoints.map((endpoint) => AppService.get(endpoint)))
      .then(([organisations, methods]) => {
        setOrganisations(organisations);
        setPaymentMethods(methods);
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  useEffect(() => {
    dispatch(updateScreenTitle("Partner Payment"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  const _submitHandler = (values, { resetForm }) => {
    dispatch(showLoader());
    AppService.post("v1/partnerPayment", values)
      .then((response) => {
        resetForm();
        dispatch(showSuccessMessage(response));
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  return (
    <WDBox>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_submitHandler}
          validationSchema={validationSchema}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <SubTitle fontSize={14}>Partner Payment</SubTitle>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <FormControl fullWidth>
                        <InputLabel id="service-label">Partner Orgnisation</InputLabel>
                        <Field
                          name="organisationId"
                          label="Partner Orgnisation"
                          fullWidth
                          as={Select}
                          error={Boolean(errors.organisationId) && Boolean(touched.organisationId)}
                        >
                          {organisations.map((item) => (
                            <MenuItem key={uuid()} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <FormControl fullWidth>
                        <InputLabel id="service-label">Payment Method</InputLabel>
                        <Field
                          name="paymentMethod"
                          label="Payment Method"
                          fullWidth
                          as={Select}
                          error={Boolean(errors.paymentMethod) && Boolean(touched.paymentMethod)}
                        >
                          {paymentMethods.map((item) => (
                            <MenuItem key={uuid()} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="amount"
                        label="amount"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.amount) && Boolean(touched.amount)}
                        helperText={Boolean(touched.amount) && errors.amount}
                      />
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default PartnerPayment;
